import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MitigatingActionReview, MitigationReviewStatus } from 'src/app/_interfaces/MitigatingActionReview.model';
import { RiskUser } from 'src/app/_interfaces/RiskUser.model';

@Component({
  selector: 'app-mitigation-review-form',
  templateUrl: './mitigation-review-form.component.html',
  styleUrls: ['./mitigation-review-form.component.css']
})
export class MitigationReviewFormComponent implements OnInit {
  @Input() mitigationReview: MitigatingActionReview;
  @Input() isNewReview: boolean;
  @Input() user: RiskUser
  @Output() onSubmit = new EventEmitter<MitigatingActionReview>();
  @Output() onCancel = new EventEmitter<void>();

  mitigationReviewForm: FormGroup;
  submitted = false;

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.initForm();
    this.patchFormValues(this.mitigationReview);
  }

  get f() { return this.mitigationReviewForm.controls; }

  get Status(): typeof MitigationReviewStatus {
    return MitigationReviewStatus;
  }

  initForm(): void {
    this.mitigationReviewForm = this.formBuilder.group({
        id: [''],
        title: ['', Validators.required],
        description: ['', Validators.required],
        reason: ['', Validators.required],
        tested: [false, Validators.required],
        effective: ['', Validators.required],
        effectivereason: ['', Validators.required],
        actionsrequired: ['', Validators.required],
        status: ['', [Validators.required, this.validateCompltedReviewStatus]],
        reviewer: [this.user.firstname + ' ' + this.user.surname, Validators.required],
        reviewDate: ['', Validators.required]
      });
  }

  validateCompltedReviewStatus(control: AbstractControl): ValidationErrors | null {
    return control.value == MitigationReviewStatus.Completed ? null : { invalidStatus: true };
  }

  patchFormValues(mitigationReview: MitigatingActionReview): void {
    this.mitigationReviewForm.patchValue({
      id: mitigationReview.id,
      title: mitigationReview.title || '',
      description: mitigationReview.description || '',
      reason: mitigationReview.decisionReason,
      tested: mitigationReview.controlTested,
      effective: mitigationReview.controlEffective,
      effectivereason: mitigationReview.effectiveReason,
      actionsrequired: mitigationReview.actionsRequired,
      status: mitigationReview.status,
      reviewDate: this.getReviewDate()
    });
  }

  getReviewDate(): string {
    if (this.isNewReview) {
      return this.formatDateForInput(new Date());
    }

    if (this.mitigationReview.mitigationReviewDate) {
      return this.formatDateForInput(this.mitigationReview.mitigationReviewDate);
    }

    return this.formatDateForInput(new Date());
  }

  formatDateForInput(date: string | Date): string {
    if (!date) return '';
    const d = new Date(date);
    // Format as yyyy-MM-dd
    return d.toISOString().slice(0, 10);
  }

  onCancelForm(): void {
    this.onCancel.emit();
  }

  onSubmitForm(): void {
    this.submitted = true;
    if (this.mitigationReviewForm.invalid) {
      return;
    }
    const formValue = this.mitigationReviewForm.getRawValue();
    const updatedReview: MitigatingActionReview = {
      ...this.mitigationReview,
      title: formValue.title,
      description: formValue.description,
      controlEffective: +formValue.effective,
      decisionReason: formValue.reason,
      controlTested: formValue.tested,
      actionsRequired: formValue.actionsrequired,
      effectiveReason: formValue.effectivereason,
      status: +formValue.status,
      mitigationReviewDate: formValue.reviewDate ? new Date(formValue.reviewDate) : null,
    };
    this.onSubmit.emit(updatedReview);
  }
}
